'use client'
import {Box, Card, Divider, Group, Stack, Text} from '@mantine/core'
import {Carousel} from '@mantine/carousel'
import {useBreakpoint} from '@/hooks/useBreakpoints'
import '@mantine/carousel/styles.css'

export default function SkuTestimonials() {
    const testimonials = [
        {
            name: 'Emerald',
            location: 'Texas',
            quote: "“I feel like I'm finally on the right path to improving my health with the right support now! It's so refreshing and reassuring.”",
        },
        {
            name: 'Kaylee',
            location: 'Louisiana',
            quote: '“My experience with General Medicine was amazing. The understanding and care that was taken to figure out what is exactly going on with me. I feel like a weight has been lifted off of me.”',
        },
        {
            name: 'Nika',
            location: 'Tennessee',
            quote: "“I couldn't be happier with my experience with General Medicine! They are fast, responsive, kind and knowledgeable. It is much easier, more affordable and faster.”",
        },
    ]

    const { isSm, isMd, isLg, isXl } = useBreakpoint()

    return (
        <Stack gap={24}>
            {renderHeader()}
            {(isMd || isLg || isXl) && <Divider bd={'1px solid var(--gm-foreground-fg-outline-primary)'}/>}
            {renderResponsiveView()}
        </Stack>
    )

    function renderHeader() {
        return (
            <Text
                c={isSm ? 'var(--Foreground-fg-primary, #1F1E1D)' : 'var(--GM-Text-Black, #181818)'}
                fw={isSm ? 'var(--gm-weight-display-small, 450)' : 400}
                fz={isSm ? 36 : 48}
                lh={isSm ? '130%' : '64px'}
                lts={isSm ? '-0.24px' : '-1.08px'}
                flex={'1 0 0'}
            >
                Thousands of customers trust us
            </Text>
        )
    }

    function renderResponsiveView() {
        // carousel for small and medium screens
        if (isSm || isMd) {
            return renderCarouselView()
        }

        return renderLargeView()
    }

    function renderCarouselView() {
        return (
            <Carousel
                slideSize="320px"
                slidesToScroll={1}
                align="start"
                slideGap={16}
                withControls={false}
                dragFree={true}
                styles={{
                    viewport: {
                        overflow: 'visible',
                    },
                }}
            >
                {testimonials.map((testimonial, index) => (
                    <Carousel.Slide key={index}>
                        <Card
                            style={{
                                height: '335px',
                                width: '320px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            }}
                            withBorder
                            bg="blue.6"
                            p={30}
                            radius={16}
                        >
                            <Text fz={22} fw={400} c={'#FFF'} lh={'28px'} style={{ flex: 1 }}>
                                {testimonial.quote}
                            </Text>
                            <Text fz={16} fw={400} c={'#FFF'} lh={'24px'}>
                                —{testimonial.name}, {testimonial.location}
                            </Text>
                        </Card>
                    </Carousel.Slide>
                ))}
            </Carousel>
        )
    }

    function renderLargeView() {
        return (
            <Group align="stretch" grow>
                {testimonials.map((testimonial, index) => (
                    <Card
                        key={index}
                        withBorder
                        bg="blue.6"
                        p="xl"
                        radius="lg"
                        h={425}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box
                            style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'flex-start',
                            }}
                        >
                            <Text fz='2xl' fw={400} c={'#FFF'} lh={'32px'}>
                                {testimonial.quote}
                            </Text>
                        </Box>
                        <Text fz='md' fw={400} c={'#FFF'} lh={'24px'}>
                            —{testimonial.name}, {testimonial.location}
                        </Text>
                    </Card>
                ))}
            </Group>
        )
    }
}
